import * as React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
// import { Link } from "react-router-dom";

export const mainListItems = (
  <React.Fragment>
    {/* <Link to={"#"} style={{ color: "inherit", textDecoration: "inherit" }}> */}
      <ListItemButton component="a" href="#">
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Dashboard" />
      </ListItemButton>
    {/* </Link> */}

    {/* <Link to={"#upload"} style={{ color: "inherit", textDecoration: "inherit" }}> */}
      <ListItemButton>
        <ListItemIcon>
          <ShoppingCartIcon />
        </ListItemIcon>
        <ListItemText primary="Upload" />
      </ListItemButton>
    {/* </Link> */}
  </React.Fragment>
);

export const secondaryListItems = (
  <React.Fragment>
    
  </React.Fragment>
);
